<template>
  <li v-if="filter">
    <div
      role="heading"
      aria-level="3"
      data-jest="filter-label"
      class="zeta mb-1 whitespace-nowrap"
    >
      {{ filter.label }}
    </div>
    <ul class="flex list-reset text-sm lg:flex-wrap gap-1">
      <li v-for="refinement in item.refinements" :key="refinement.label">
        <BaseTag
          data-jest="filter-selection-tag"
          class="bg-red-800 text-white hover:bg-red-900"
          removable
          title="Poista rajaus"
          @click="item.refine(refinement)"
        >
          <span v-if="isColor" class="rounded-full size-4" :style="getStyles(refinement)" />{{ createLabel(refinement) }}
        </BaseTag>
      </li>
    </ul>
  </li>
</template>

<script setup lang="ts">
import BaseTag from '~/components/BaseTag.vue'
import { useProductFilterStore } from '~/stores/productFilter'
import { useProductFilter } from '~/composables/useProductFilter'
import type { ProductFilter } from '~/types/productFilter'
import type { AisRefinementAttributeItem } from '~/types/instantsearch'

const props = defineProps({
  item: {
    type: Object,
    required: true
  }
})

const productFilterStore = useProductFilterStore()
const filter: ComputedRef<ProductFilter | null> = computed(() => productFilterStore.getProductFilterByAttributePath(props.item.attribute))
const isColor = computed(() => filter.value?.type === 'color')
const { getFilterOptionLabel } = useProductFilter()
const { parseSwatchColor } = useSwatch()
const createLabel = (refinement: AisRefinementAttributeItem) => {
  let label = getFilterOptionLabel(refinement?.value + '')
  if (isColor.value) {
    const { name: colorName } = parseSwatchColor(refinement.label)
    label = colorName
  }
  else if (filter.value?.type === 'toggle') {
    label = filter.value?.label
  }
  const affix = filter.value?.unit || ''
  const prefix = refinement?.operator?.replace('<=', 'max.').replace('>=', 'min.') || ''
  return (prefix + ' ' + label + ' ' + affix).trim()
}
const getStyles = (refinement: AisRefinementAttributeItem) => {
  if (filter.value?.type === 'color') {
    const { style } = parseSwatchColor(refinement.label, { border: false })
    return style
  }
  return {}
}
</script>
